/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { AuthenticationService } from '../../common/authentication/service/AuthenticationService';
import { PjInjectProxy } from '../../common/extends_fw/PjInjectProxy';
import { PjBaseController, Alert } from '../../common/extends_fw/controller/PjBaseController';
import { PjServiceResponse } from '../../common/extends_fw/service/PjServiceResponse';
import { MsgLevel } from '../../framework/controller/MsgLevel';
import { ViewingHistoryService } from '../service/ViewingHistoryService';
import { HistoryCriteriaJson } from '../json/JsonAll';
import { HistoryListJson } from '../json/JsonAll';
import { SharedService } from '../../common/extends_fw/controller/PjBaseController';

/**
 * 履歴確認画面について出力処理およびイベント処理を行う。
 */
export class ViewingHistoryController extends PjBaseController {

    // 会社名
    public companyName: string;

    // ユーザ名
    public userName: string;

    // 動画名
    public video: string;

    // 視聴日付
    public viewingDate: string;

    // グリッド情報
    public gridOptions: any;

    // 検索情報
    public criteria: HistoryCriteriaJson;

    /**
     * コンストラクタ
     */
    /* @ngInject */
    public constructor(
            protected $stateParams: angular.ui.IStateParamsService,
            protected $window: ng.IWindowService,
            protected $translate: ng.translate.ITranslateService,
            protected pjInjectProxy: PjInjectProxy,
            protected viewingHistoryService: ViewingHistoryService,
            protected $location: ng.ILocationService,
            protected sharedService: SharedService,
            protected $scope: any) {
        super($stateParams, $translate, $location, pjInjectProxy);

        if (!this.checkAuthenticatedUser()) {
            return;
        }

        this.setTitle('form07.title');
        this.gridOptions = {
            columnDefs: [
                {
                    field: 'userName',
                    displayName: 'item.0092',
                    width: '28%',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'video',
                    displayName: 'item.0065',
                    headerCellFilter: 'translate'
                },
                {
                    field: 'viewingDate',
                    displayName: 'item.0044',
                    width: '18%',
                    headerCellFilter: 'translate'
                }
            ],
            enableColumnMenus: false,
            enableHorizontalScrollbar: 0,
            enableColumnResizing: true,
            paginationPageSizes: [10, 25, 100],
            paginationPageSize: 10,
            onRegisterApi: (gridApi: any) : void => {
                this.$scope.gridApi = gridApi;
            },
        };
        this.draw();

        // 検索初期条件設定
        if ($stateParams.page === 'user') {
            this.userName = $stateParams.name;
        } else {
            this.video = $stateParams.name.replace(/_slash-/g,'/');
        }

        //  項目の表示制御
        $scope.tohmatsu = this.isTohmatsu();

        let auth: any = {};
        auth = sharedService.get('auth');

        if (auth && auth.role !== 2) {
            this.gridOptions.columnDefs.unshift({
                field: 'companyName',
                displayName: 'item.0016',
                headerCellFilter: 'translate'
            });
        }
    }

    public reflesh_list(): void {
        this.viewingHistoryService.list(this.criteria).then((data: any) => {
            this.gridOptions.data.splice(0, this.gridOptions.data.length);
            Array.prototype.push.apply(this.gridOptions.data, data.data.viewhistories);
            this.clearAlert();
            if (data.status === 204) {
                this.setAlert('message.0004');
            }
        }).catch((errorData: any) => {
            this.catch(errorData);
        });
    }

    /**
     * 検索処理
     */
    public search(): void {
        let criteria: any = {
            companyName: this.companyName,
            userName: this.userName,
            video: this.video,
            viewingDate: this.viewingDate
        };
        this.criteria = criteria;
        this.reflesh_list();
    }

    public close(): void {
        if (this.$stateParams.page === 'user') {
            this.$location.url('/user');
        } else if (this.$stateParams.page === 'video') {
            this.$location.url('/video');
        } else {
            this.$location.url('/top');
        }
    }

    /**
     * 復元処理
     * @param {any} data 復元用データ
     */
    public restore(data: any): void {}

    /**
     * 表示処理
     */
    public show(): void {}
}




/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/ma/controller/ViewingHistoryController.ts
 **/